import { Device } from 'DeviceUtils';
import favoritesSettingsStyles from '../FavoritesSettings.jss';

const favoritesInputProps = {
    style: favoritesSettingsStyles.searchInput,
    containerStyle: Device.isTablet ? favoritesSettingsStyles.searchInputContainer : {},
    autoCorrect: false,
    autoCapitalize: 'sentences',
    secureTextEntry: false,
    testID: 'search_channel_input'
};

export default favoritesInputProps;
